<template>
  <el-dialog v-dialogDrag width="600px" title="添加目录" top="50px" :visible.sync="allModuleProp.editVisible"
    :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="editModule" label-width="80px" :rules="allModuleProp.rules" :model="moduleForm" size="small">
      <el-form-item label="父 级" prop="parentId">
        <div>{{ parentFolder.folderName }}</div>
      </el-form-item>
      <el-form-item label="类 型" prop="folderType">
        <el-select v-model="moduleForm.folderType" size="small" placeholder="请选择类型" style="width:100%" filterable>
          <el-option 
            v-for="item in folderTypeList" 
            :key="item.dicId" 
            :label="item.cnName"
            :value="item.dicId" 
          />
        </el-select>
      </el-form-item>
      <el-form-item label="名 称" prop="folderName">
        <div v-if="isAdd">
          <el-input v-model="moduleForm.folderName" type="textarea" />
          <p>
            提示：可一次性添加多个目录，每个目录占一行
          </p>
        </div>
        <div v-else>
          <el-input v-model="moduleForm.folderName" />
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button size="small" @click="allModuleProp.editVisible = false">关闭</el-button>
      <el-button v-if="isAdd" type="primary" size="small" @click="submitEditModuleHandler()">新建</el-button>
      <el-button v-if="allModuleProp.editType === 2" type="primary" size="small" @click="submitEditModuleHandler()">更新</el-button>
    </template>
  </el-dialog>
</template>

<script>
import folderTemplateService from "@/CommonDP/service/admin/folderTemplate-service";
import folderTypeList from "./folderType";
export default {
  data() {
    return {
      parentFolder: {},
      allModuleProp: {
        visible: false,
        editVisible: false,
        rules: {
          pid: [{ required: true, message: "请选择父级名称", trigger: "change" }],
          permissionName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          resourceType: [{ required: true, message: "请选择类型", trigger: "change" }],
          moduleUrl: [{ required: true, message: "请输入外链地址", trigger: "blur" }]
        },
        editType: 0 // 0新建 1查看 2编辑
      },
      moduleForm: {
        folderType: 99,
        folderName: ""
      },
    };
  },
  computed: {
    isAdd() {
      return this.allModuleProp.editType === 0;
    },
    // 模块提交的数据
    addModuleForm() {
      const { moduleForm } = this;
      return { systemUse: 0, ...moduleForm };
    },
    folderTypeList(){
      return folderTypeList || [];
    }
  },
  methods: {
    showAddDlg(parentFolder) {
      console.debug("parentFolder,,,,", parentFolder);
      this.parentFolder = parentFolder;
      this.moduleForm.folderType = parentFolder.folderType;
      this.moduleForm.folderTemplateTypeId = parentFolder.folderTemplateTypeId;
      this.allModuleProp.editVisible = true;
      this.$nextTick(() => {
        this.$refs.editModule.clearValidate();
      });
      this.editType = 0;
    },

    async submitEditModuleHandler() {
      const form = this.moduleForm;
      await this.$refs.editModule.validate();
      if (this.isAdd) {
        form.parentId = this.parentFolder.folderId;
        form.folderNames = form.folderName.split("\n");
        await folderTemplateService.create(form);
        this.$message.success("添加成功");
        this.$emit("ok");
      } else {
        this.$error("未实现");
        console.error("未实现");
      }
      this.closeEditModule();
    },
    closeEditModule() {
      this.allModuleProp.editVisible = false;
    }
  }
};
</script>
<style lang="scss">
.form {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
.messageCenter {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;
}
</style>
